export class Artist {
    constructor() {
    }

    artistId: string;
    name: string;
    picture: string;
}
